if (typeof window !== 'undefined') {
  // Suppress ResizeObserver loop notifications.
  // These fire when a ResizeObserver callback can't deliver all observations
  // in a single animation frame -- benign browser behavior from Radix/shadcn.
  window.addEventListener('error', (event) => {
    if (event.message?.includes('ResizeObserver loop')) {
      event.stopImmediatePropagation();
      event.preventDefault();
    }
  });

  // Suppress unhandled promise rejections with undefined/null values.
  // These are synthetic exceptions from third-party scripts (CobrowseIO, PostHog SDK,
  // browser extensions) that reject promises without an Error object.
  window.addEventListener('unhandledrejection', (event) => {
    if (event.reason === undefined || event.reason === null) {
      event.preventDefault();
    }
  });
}
